// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Radio EPG Modal Styles */
.radio-epg-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.3s ease;
}

.radio-epg-modal {
    width: 90%;
    max-width: 800px;
    max-height: 90vh;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    display: flex;
    flex-direction: column;
    animation: slideUp 0.3s ease;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(50px) scale(0.9);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Header */
.epg-modal-header {
    padding: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.epg-header-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.station-info {
    display: flex;
    align-items: center;
    gap: 16px;
}

.station-logo {
    width: 60px;
    height: 60px;
    border-radius: 12px;
    object-fit: cover;
    border: 2px solid rgba(255, 255, 255, 0.1);
}

.station-details .station-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 8px 0;
}

.live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.live-indicator .live-icon {
    color: #ff4444;
    animation: pulse 2s infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    padding: 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    opacity: 0.7;
}

.close-btn:hover {
    opacity: 1;
    background: rgba(255, 255, 255, 0.1);
}

/* Date Selector */
.date-selector {
    display: flex;
    align-items: center;
    gap: 12px;
}

.calendar-icon {
    font-size: 18px;
    opacity: 0.7;
}

.date-input {
    padding: 10px 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    font-size: 14px;
    background: transparent;
    cursor: pointer;
    transition: all 0.2s ease;
}

.date-input:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.4);
}

/* Current Program Highlight */
.current-program-highlight {
    margin: 24px;
    padding: 20px;
    border-radius: 12px;
    border-left: 4px solid #ff4444;
    position: relative;
}

.current-program-badge {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #ff4444;
    margin-bottom: 12px;
}

.current-program-info .program-title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
}

.current-program-info .program-description {
    margin: 0 0 12px 0;
    line-height: 1.5;
}

.program-time {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
}

.clock-icon {
    opacity: 0.7;
}

/* Program Schedule */
.program-schedule {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.schedule-title {
    padding: 0 24px 16px 24px;
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 12px;
}

.schedule-icon {
    opacity: 0.7;
}

/* Loading/Error States */
.epg-loading,
.epg-error,
.no-programs {
    padding: 40px 24px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top: 3px solid #ffffff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.no-programs-icon {
    font-size: 48px;
    opacity: 0.3;
}

.retry-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
}

.retry-btn:hover {
    transform: translateY(-1px);
}

/* Programs List */
.programs-list {
    flex: 1 1;
    overflow-y: auto;
    padding: 0 24px;
    max-height: 400px;
}

.program-item {
    display: flex;
    gap: 20px;
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 12px;
    transition: all 0.2s ease;
    border: 1px solid transparent;
}

.program-item:hover {
    border-color: rgba(255, 255, 255, 0.1);
    transform: translateX(4px);
}

.program-item.current-program {
    border-left: 4px solid #ff4444;
    background: linear-gradient(90deg, rgba(255, 68, 68, 0.1) 0%, transparent 100%);
}

.program-time-slot {
    flex-shrink: 0;
    width: 80px;
    text-align: center;
}

.start-time {
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.2;
}

.end-time {
    display: block;
    font-size: 12px;
    margin-top: 2px;
}

.program-content {
    flex: 1 1;
}

.program-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

.program-name {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
}

.live-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ff4444;
    background: rgba(255, 68, 68, 0.1);
    padding: 4px 8px;
    border-radius: 12px;
    border: 1px solid rgba(255, 68, 68, 0.3);
}

.program-desc {
    margin: 0 0 12px 0;
    line-height: 1.4;
    font-size: 14px;
}

.program-meta {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 12px;
}

.program-type {
    display: flex;
    align-items: center;
    gap: 6px;
}

.meta-icon {
    opacity: 0.7;
}

/* Footer */
.epg-modal-footer {
    padding: 20px 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.epg-info {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}

.info-icon {
    opacity: 0.7;
}

.close-modal-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
}

.close-modal-btn:hover {
    transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 768px) {
    .radio-epg-modal {
        width: 95%;
        max-height: 95vh;
    }

    .epg-modal-header {
        padding: 20px;
    }

    .station-info {
        gap: 12px;
    }

    .station-logo {
        width: 50px;
        height: 50px;
    }

    .station-details .station-title {
        font-size: 20px;
    }

    .current-program-highlight {
        margin: 20px;
        padding: 16px;
    }

    .programs-list {
        padding: 0 20px;
    }

    .program-item {
        flex-direction: column;
        gap: 12px;
    }

    .program-time-slot {
        width: auto;
        text-align: left;
    }

    .start-time,
    .end-time {
        display: inline;
        margin-right: 8px;
    }

    .epg-modal-footer {
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }

    .close-modal-btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .epg-header-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .close-btn {
        align-self: flex-end;
    }

    .current-program-info .program-title {
        font-size: 16px;
    }

    .schedule-title {
        font-size: 18px;
        padding: 0 20px 16px 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Music/RadioStation/Components/Styles/RadioEPGModal.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI;QACI,UAAU;QACV,sCAAsC;IAC1C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,WAAW;AACX;IACI,aAAa;IACb,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sCAAsC;AAC1C;;AAEA,8BAA8B;AAC9B;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;AACzB;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,kBAAkB;AAClB;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,+EAA+E;AACnF;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kCAAkC;IAClC,gBAAgB;IAChB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;AAChB;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,8CAA8C;IAC9C,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Radio EPG Modal Styles */\n.radio-epg-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n    animation: fadeIn 0.3s ease;\n}\n\n.radio-epg-modal {\n    width: 90%;\n    max-width: 800px;\n    max-height: 90vh;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n    display: flex;\n    flex-direction: column;\n    animation: slideUp 0.3s ease;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(50px) scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0) scale(1);\n    }\n}\n\n/* Header */\n.epg-modal-header {\n    padding: 24px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.epg-header-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.station-info {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.station-logo {\n    width: 60px;\n    height: 60px;\n    border-radius: 12px;\n    object-fit: cover;\n    border: 2px solid rgba(255, 255, 255, 0.1);\n}\n\n.station-details .station-title {\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 0 8px 0;\n}\n\n.live-indicator {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.live-indicator .live-icon {\n    color: #ff4444;\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    opacity: 0.7;\n}\n\n.close-btn:hover {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.1);\n}\n\n/* Date Selector */\n.date-selector {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.calendar-icon {\n    font-size: 18px;\n    opacity: 0.7;\n}\n\n.date-input {\n    padding: 10px 16px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 8px;\n    font-size: 14px;\n    background: transparent;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.date-input:focus {\n    outline: none;\n    border-color: rgba(255, 255, 255, 0.4);\n}\n\n/* Current Program Highlight */\n.current-program-highlight {\n    margin: 24px;\n    padding: 20px;\n    border-radius: 12px;\n    border-left: 4px solid #ff4444;\n    position: relative;\n}\n\n.current-program-badge {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #ff4444;\n    margin-bottom: 12px;\n}\n\n.current-program-info .program-title {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 0 0 8px 0;\n}\n\n.current-program-info .program-description {\n    margin: 0 0 12px 0;\n    line-height: 1.5;\n}\n\n.program-time {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.clock-icon {\n    opacity: 0.7;\n}\n\n/* Program Schedule */\n.program-schedule {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.schedule-title {\n    padding: 0 24px 16px 24px;\n    margin: 0;\n    font-size: 20px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.schedule-icon {\n    opacity: 0.7;\n}\n\n/* Loading/Error States */\n.epg-loading,\n.epg-error,\n.no-programs {\n    padding: 40px 24px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n}\n\n.loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid rgba(255, 255, 255, 0.1);\n    border-top: 3px solid #ffffff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.no-programs-icon {\n    font-size: 48px;\n    opacity: 0.3;\n}\n\n.retry-btn {\n    padding: 8px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-weight: 500;\n    transition: all 0.2s ease;\n}\n\n.retry-btn:hover {\n    transform: translateY(-1px);\n}\n\n/* Programs List */\n.programs-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0 24px;\n    max-height: 400px;\n}\n\n.program-item {\n    display: flex;\n    gap: 20px;\n    padding: 16px;\n    border-radius: 12px;\n    margin-bottom: 12px;\n    transition: all 0.2s ease;\n    border: 1px solid transparent;\n}\n\n.program-item:hover {\n    border-color: rgba(255, 255, 255, 0.1);\n    transform: translateX(4px);\n}\n\n.program-item.current-program {\n    border-left: 4px solid #ff4444;\n    background: linear-gradient(90deg, rgba(255, 68, 68, 0.1) 0%, transparent 100%);\n}\n\n.program-time-slot {\n    flex-shrink: 0;\n    width: 80px;\n    text-align: center;\n}\n\n.start-time {\n    display: block;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.2;\n}\n\n.end-time {\n    display: block;\n    font-size: 12px;\n    margin-top: 2px;\n}\n\n.program-content {\n    flex: 1;\n}\n\n.program-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n}\n\n.program-name {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n    flex: 1;\n}\n\n.live-badge {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #ff4444;\n    background: rgba(255, 68, 68, 0.1);\n    padding: 4px 8px;\n    border-radius: 12px;\n    border: 1px solid rgba(255, 68, 68, 0.3);\n}\n\n.program-desc {\n    margin: 0 0 12px 0;\n    line-height: 1.4;\n    font-size: 14px;\n}\n\n.program-meta {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    font-size: 12px;\n}\n\n.program-type {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.meta-icon {\n    opacity: 0.7;\n}\n\n/* Footer */\n.epg-modal-footer {\n    padding: 20px 24px;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.epg-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n}\n\n.info-icon {\n    opacity: 0.7;\n}\n\n.close-modal-btn {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.close-modal-btn:hover {\n    transform: translateY(-1px);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .radio-epg-modal {\n        width: 95%;\n        max-height: 95vh;\n    }\n\n    .epg-modal-header {\n        padding: 20px;\n    }\n\n    .station-info {\n        gap: 12px;\n    }\n\n    .station-logo {\n        width: 50px;\n        height: 50px;\n    }\n\n    .station-details .station-title {\n        font-size: 20px;\n    }\n\n    .current-program-highlight {\n        margin: 20px;\n        padding: 16px;\n    }\n\n    .programs-list {\n        padding: 0 20px;\n    }\n\n    .program-item {\n        flex-direction: column;\n        gap: 12px;\n    }\n\n    .program-time-slot {\n        width: auto;\n        text-align: left;\n    }\n\n    .start-time,\n    .end-time {\n        display: inline;\n        margin-right: 8px;\n    }\n\n    .epg-modal-footer {\n        flex-direction: column;\n        gap: 16px;\n        align-items: stretch;\n    }\n\n    .close-modal-btn {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .epg-header-info {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 16px;\n    }\n\n    .close-btn {\n        align-self: flex-end;\n    }\n\n    .current-program-info .program-title {\n        font-size: 16px;\n    }\n\n    .schedule-title {\n        font-size: 18px;\n        padding: 0 20px 16px 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
